import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { formId } from "./constants";

interface ModalFooterProps {
  isSubmitDisabled: boolean;
}

export const ModalFooter = ({ isSubmitDisabled }: ModalFooterProps) => (
  <div className="flex w-full justify-end">
    <Button
      type="submit"
      form={formId}
      variant="circle"
      disabled={isSubmitDisabled}
    >
      {t("save")}
    </Button>
  </div>
);
